module.exports = __webpack_public_path__ + "img/Samsson.ce4274f3.png";